import { render } from "./ModuleAggregateView.vue?vue&type=template&id=957067c8&scoped=true"
import script from "./ModuleAggregateView.vue?vue&type=script&lang=js"
export * from "./ModuleAggregateView.vue?vue&type=script&lang=js"

import "./ModuleAggregateView.vue?vue&type=style&index=0&id=957067c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957067c8"]])

export default __exports__